export enum FeedbackType {
  BUG = "BUG",
  FEATURE_REQUEST = "FEATURE_REQUEST",
  GENERAL_FEEDBACK = "GENERAL_FEEDBACK",
  SUPPORT_REQUEST = "SUPPORT_REQUEST",
}

export enum FeedbackPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export interface Feedback {
  id?: number;
  managerId: number;
  type: FeedbackType;
  subject: string;
  message: string;
  priority?: FeedbackPriority;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateFeedbackPayload {
  managerId: number;
  type: FeedbackType;
  subject: string;
  message: string;
  priority?: FeedbackPriority;
}

